import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowCounterClockwise } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-bone flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="noise-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="max-w-lg w-full border border-forest/20 bg-bone p-10 text-center shadow-xl"
      >
        <ArrowCounterClockwise size={52} weight="duotone" className="text-terra mx-auto mb-6" />
        <h1 className="font-serif font-bold tracking-tighter text-forest text-4xl" data-testid="payment-cancel-heading">
          No charge was made.
        </h1>
        <p className="text-base text-moss mt-4 leading-relaxed">
          You left the secure checkout before completing your gift. Whenever you&apos;re ready,
          the children will be too.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link to="/#get-involved" data-testid="payment-retry-link"
            className="bg-terra text-bone font-bold px-8 py-4 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200">
            Try again
          </Link>
          <Link to="/" data-testid="payment-home-link"
            className="border border-forest/30 text-forest font-bold px-8 py-4 hover:bg-forest hover:text-bone transition-colors duration-200">
            Back home
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
